import { createSlice } from "@reduxjs/toolkit";
import {
  fetchManPowers,
  fetchManPowersById,
  updateStatusInManPower,
  updateManPower,
  fetchAllDropdowns,
  exportManPowersCSV,
  fetchAllDropdownsManPowers,
} from "./thunk";

interface ManPowersState {
  manPowerList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  orgDropDown: any[];
  departmentDropDown: any[];
  orgCityDropDown: any[];
  manPowersDropDown: any[];

  dropdownOptions: Record<string, any[]>;
}

const initialState: ManPowersState = {
  manPowerList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  exportCSVLoading: false,
  exportCSVError: null,
  dropdownOptions: {},
  orgDropDown: [],
  departmentDropDown: [],
  orgCityDropDown: [],
  manPowersDropDown: [],
};

const manPowerSlice = createSlice({
  name: "manPowers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All ManPowers
      .addCase(fetchManPowers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManPowers.fulfilled, (state, action) => {
        state.loading = false;
        state.manPowerList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchManPowers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch manPowers";
      })

      // Fetch Single ManPower by ID
      .addCase(fetchManPowersById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchManPowersById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update ManPower
      .addCase(updateManPower.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.manPowerList = state.manPowerList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateManPower.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update manPower";
      })

      // Update Status
      .addCase(updateStatusInManPower.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.manPowerList = state.manPowerList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInManPower.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update manPower status";
      })
      .addCase(exportManPowersCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportManPowersCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportManPowersCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      })
      .addCase(fetchAllDropdownsManPowers.fulfilled, (state, action) => {
        state.orgDropDown = action.payload.orgDropDown || [];
        state.departmentDropDown = action.payload.departmentDropDown || [];
        state.manPowersDropDown = action.payload.manPowersDropDown || [];
      });
  },
});

export default manPowerSlice.reducer;
